module.exports = __webpack_public_path__ + "media/assets/icons/service-2f6c475a67ede9448f0740fcd6073126.svg";